import { FeatureFlagService } from '../featureFlagService';
import { Stage } from '@xbcb/core';

const MULTI_BROKER_LOGIN_FEATURE = new FeatureFlagService([
  {
    feature: 'MULTI_BROKER_LOGIN_FEATURE',
    enabled: true,
    stages: [Stage.ALPHA, Stage.BETA],
    teams: {
      [Stage.ALPHA]: ['assignmentTeam_48b4bc54-b658-4832-a383-b27770f623c1'],
      [Stage.BETA]: [],
    },
  },
]);

export { MULTI_BROKER_LOGIN_FEATURE };
